import {
  Box, Container, Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';

import { capitalizeFirstLetter } from '../../utils';

import { ContactInfo } from './ContactInfo';

import type { FC } from 'react';


interface Address {
  tel: string;
  fax: string;
  email: string;
  street: {
    name: string;
    number: string;
  };
  zipcode: string;
  city: string;
}

export interface ArrivalProps {
  header: string;
  car: {
    header: string;
    parkingLots: string[];
  };
  publicTransportation: {
    header: string;
    stops: string[];
  };
}

export interface ContactInfoProps {
  header: string;
  address: Address;
  content: ArrivalProps;
  openingHours: Array<{ day: string; time: string }>;
}

const RootStyle = styled('div')(
  ( { theme } ) => (
    {
      padding: theme.spacing(8, 0),
      backgroundColor: theme.palette.background.neutral,
      [theme.breakpoints.up('md')]: { padding: theme.spacing(10, 0) },
    }
  )
);

export const ContactUs: FC<ContactInfoProps> = (
  {
    header, address, content, openingHours
  }
) => (
  <RootStyle>
    <Container>
      <Typography
        variant="h2"
        textAlign={{ xs: 'center', md: 'left' }}
        mt={2}
        mb={3}
      >
        {capitalizeFirstLetter(header)}
      </Typography>
      <Box paddingBottom={6}>
        <ContactInfo
          openingHours={openingHours}
          footer={content}
          address={address}
        />
      </Box>
    </Container>
  </RootStyle>
);
